import { atom } from 'recoil';

// notification state

export const notificationState = atom({
  key: 'notificationState',
  default: false,
});

// customer state

export const customerState = atom({
  key: 'customerState',
  default: {
    customerId: null,
    customers: [],
    companyName: '',
  },
});
